<template>
  <div>
    <Header />

    <div class="hero" id="top">
      <b-container>
        <b-row>
          <b-col cols="12" md="8">
            <h1>Hi! I'm Diana Gamarra,</h1>
            <br />
            <p>A polyvalent graphic and UI designer with a curious mind and always eager to take on new challenges. In my work, I aim to create engaging and enjoyable experiences for users.</p>
            <button onClick="window.open('/resume.pdf', '_blank').focus()">View Resume (FR/EN)</button><br /><br />
            <span><a href="mailto:gamarradiana13@gmail.com"><img class="email" src="/images/email.svg" width="40" height="40" /></a></span>
            <span><a href="https://www.linkedin.com/in/gamarradiana/"><img class="linkedin" src="/images/linkedin.svg" width="40" height="40" /></a></span>
          </b-col>
          <b-col cols="12" md="4">
            <img class="me" src="/images/me.webp" />
          </b-col>
        </b-row>
        <b-row>

        </b-row>
        <b-col class="arrow-see-more">
          Press the images to see more<br/>
          <img src="/images/arrow.svg" class="arrow-bottom" width="42" />
        </b-col>
      </b-container>
    </div>

    <b-container fluid="lg" id="my-work">
      <div id="two-side">
        <div id="portfolio">
          <b-row>
            <b-col cols="12" md="6">
              <div class="tn thumbnail-1" @click="redirectTo('cashaway')">
                <div class="overlay">
                  <h1><b>UI Design</b><br /><br />CashAway - A banking app for travellers</h1>
                </div>
              </div>
            </b-col>
            <b-col cols="12" md="6">
              <div class="tn thumbnail-2" @click="redirectTo('fres-ka')">
                <div class="overlay">
                  <h1><b>Fres-Ka</b><br /><br />Korean beauty e-commerce website</h1>
                </div>
              </div>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="12" md="4">
              <div class="tn thumbnail-6" @click="redirectTo('banners')">
                <div class="overlay">
                  <h1><b>Banners</b></h1>
                </div>
              </div>
            </b-col>
            <b-col cols="12" md="4">
              <div class="col dd tn thumbnail-7" @click="redirectTo('advertising')">
                <div class="overlay">
                  <h1><b>Advertising</b></h1>
                </div>
              </div>
            </b-col>
            <b-col cols="12" md="4">
              <div class="col dd tn thumbnail-8" @click="redirectTo('publication')">
                <div class="overlay">
                  <h1><b>Publication</b></h1>
                </div>
              </div>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="12" md="6">
              <div class="tn thumbnail-3" @click="redirectTo('jlgs')">
                <div class="overlay">
                  <h1><b>JLGS</b><br /><br />Presentation website for an engineering company</h1>
                </div>
              </div>
            </b-col>
            <b-col cols="12" md="6">
              <div class="col dd tn thumbnail-4" @click="redirectTo('visual-identity')">
                <div class="overlay">
                  <h1><b>Graphic Design</b><br /><br />Visual Identity and Logo Design</h1>
                </div>
              </div>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="12">
              <div class="col dd tn thumbnail-5" @click="redirectTo('travel-guide')">
                <div class="overlay">
                  <h1><b>Graphic Design - Print</b><br />Travel Guide</h1>
                </div>
              </div>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-container>

   <Footer />
  </div>
</template>

<script>
import Header from "./components/Header.vue";
import Footer from "./components/Footer.vue";

export default {
  components: { Header, Footer },
  name: "Home",
  data() {
    return {};
  },
  computed: {},
  methods: {
    redirectTo(url) {
      this.$router.push('/' + url);
    }
  },
  mounted() { },
};
</script>

<style lang="scss">
$mobile-bp: 800px;

.hero {
  margin-top: 60px;
  font-family: "Inter", sans-serif;
  font-weight: 300;
  color: rgba(0, 0, 0, 0.79);

  h1 {
    font-size: 32pt;
  }

  p {
    font-size: 14pt;
  }

  button {
    border: 0;
    background-color: #0077B5;
    padding: 10px 30px;
    color: white;
  }

  img.me {
    height: 340px;
    max-height: 35vh;
    margin-left: auto;
    margin-right: auto;
    display: block;

    @media (max-width: 768px) {
      margin-top: 40px;
    }
  }

  .arrow-see-more {
    text-align: center;
    margin-top: 100px;
    color: rgba(0, 0, 0, 0.3);
    font-style: italic;
    img {
      margin-top: 15px;
    }
  }

  img.linkedin {
    margin-left: 15px;
  }

  img.email {
    margin-left: -3px;
  }
}

#two-side {
  //display: flex;
  font-family: "Inter", sans-serif;

  @media (max-width: $mobile-bp) {
    flex-wrap: wrap;
  }


  #portfolio {
    margin-top: 39px;

    flex-grow: 1;

    div[class^="col-"] {
      margin-top: 30px;
    }

    .tn {
      min-height: 450px;
      background-size: cover;
      background-position: center;

      padding: 0;
      cursor: pointer;
      position: relative;

      .overlay {
        background: rgba(45, 30, 85, 0.69);
        height: 100%;
        width: 100%;
        opacity: 0;
        transition: 0.5s;
        padding: 15px;

        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;

        h1 {
          color: white;
          text-align: center;
          font-size: 18pt;

          b {
            font-size: 28pt;
          }
        }
      }

      &:hover .overlay {
        opacity: 1;
      }
    }

    .thumbnail-1 {
      background-image: url("/images/thumbnails/cashaway.webp");
    }

    .thumbnail-2 {
      background-image: url("/images/thumbnails/freska.webp");
    }

    .thumbnail-3 {
      background-image: url("/images/thumbnails/jlgs.webp");
    }

    .thumbnail-4 {
      background-image: url("/images/thumbnails/visual-identity-logo-design.webp");
    }

    .thumbnail-5 {
      background-image: url("/images/thumbnails/print-travel-guide.webp");
    }

    .thumbnail-6 {
      background-image: url("/images/thumbnails/jazzfestival.webp");
    }

    .thumbnail-7 {
      background-image: url("/images/thumbnails/adthumbnail.webp");
    }

    .thumbnail-8 {
      background-image: url("/images/thumbnails/publication.webp");
    }
  }
}
</style>